import React from "react";
import { View } from "react-native";
import i18n from "utils/i18n";
import _ from 'lodash'
import ThemedBlock from 'components/atoms/ThemedBlock'
import Form from 'components/molecules/Form'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import { IconTimeslotConstants } from 'utils/constants/IconNameConstants'
import { colorList } from 'utils/colors'
import { timeslotKindConstants } from 'utils/constants/timeslot-kind-constants'
import { FormStyles } from 'styles/components/molecules/Form'
import Icon from 'components/atoms/Icon'
import { FormFieldsConstants } from 'utils/constants/form-constants'
import PreviewTimeslotKind from 'scenes/management/timeslots/timeslot_kind/_components/PreviewTimeslotKind'
import VStack from 'components/atoms/stack/VStack'

const ManagementTimeslotKindIconTab = ( { loading, saveForm, updateTimeslotKind, timeslotKind, isSaving }) => {
	
	const formFields = [];
	
	let icons = [];
	
	_.forEach( IconTimeslotConstants, ( IconNameConstant ) => {
		icons.push({
			key: IconNameConstant,
			value: IconNameConstant
		});
	});
	
	let iconColors = [];
	let backgroundColors = [];
	
	_.forEach( [ colorList.WHITE.primary, colorList.BLACK.primary ], ( color ) => {
		iconColors.push({
			key: color,
			value: color
		});
	});
	
	_.forEach( colorList.ICONS, ( color ) => {
		backgroundColors.push({
			key: color,
			value: color
		});
	});
	
	if( _.get( timeslotKind, 'kind', null ) === timeslotKindConstants.CUSTOM ){
		formFields.push({
			name: 'icon',
			label: i18n.t('management:form.icon.title'),
			type: FormFieldsConstants.ITEM_PICKER,
			renderItem: ( option, selected, disabled ) => {
				return (
					<View style={ [ FormStyles.itemPickerItem, selected ? FormStyles.itemPickerItemSelected : null, disabled ? FormStyles.itemPickerItemDisabled : null  ]} >
						{ <Icon icon={ option.key } /> }
					</View>
				);
			},
			options: icons
		});
	}
	
	formFields.push({
		name: 'sub_icon',
		label: i18n.t('management:form.sub_icon.title'),
		type: FormFieldsConstants.ITEM_PICKER,
		renderItem: ( option, selected, disabled ) => {
			return (
				<View style={ [ FormStyles.itemPickerItem, selected ? FormStyles.itemPickerItemSelected : null, disabled ? FormStyles.itemPickerItemDisabled : null  ]}>
					{ option.key !== null && (
						<Icon icon={ option.key } />
					)}
				</View>
			);
		},
		options: [
			...[ { key: null, value: null } ],
			...icons
		]
	});
	
	if( _.get( timeslotKind, 'kind', null ) === timeslotKindConstants.CUSTOM ){
		formFields.push({
			name: 'icon_color',
			label: i18n.t('management:form.icon_color.title'),
			type: FormFieldsConstants.ITEM_PICKER,
			renderItem: ( option, selected, disabled ) => {
				return (
					<View style={ [ FormStyles.itemPickerItem, selected ? FormStyles.itemPickerItemSelected : null, disabled ? FormStyles.itemPickerItemDisabled : null,  { backgroundColor: option.key } ]} />
				);
			},
			options: iconColors
		});
		
		formFields.push({
			name: 'background_color',
			label: i18n.t('management:form.background_color.title'),
			type: FormFieldsConstants.ITEM_PICKER,
			renderItem: ( option, selected, disabled ) => {
				return (
					<View style={ [ FormStyles.itemPickerItem, selected ? FormStyles.itemPickerItemSelected : null, disabled ? FormStyles.itemPickerItemDisabled : null, { backgroundColor: option.key } ]} />
				);
			},
			options: backgroundColors
		});
	}
	
	return (
		<VStack>
			<PreviewTimeslotKind
				timeslotKind={ timeslotKind }
			/>
			
			<ThemedBlock
				shadow
				mediumPadding>
				<Form
					values={ timeslotKind }
					fields={ formFields }
					onChange={ updateTimeslotKind }
					onSubmit={ saveForm }
					disabled={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.TIMESLOTS ) || isSaving }
					forceSaveButton={ true }
				/>
			</ThemedBlock>
		</VStack>
	);
}


export default ManagementTimeslotKindIconTab
